import React, {useEffect, useRef, useState} from 'react';
import {stainChange} from '../hungerEffects';

// Une place par tache, sur les bords de l'écran (jamais au centre de la fiche)
const SPOTS = [
  {top: '8%', left: '-24px', size: 120, rotate: 20},
  {bottom: '12%', right: '-28px', size: 140, rotate: -35},
  {top: '-32px', right: '24%', size: 110, rotate: 80},
  {bottom: '-34px', left: '30%', size: 130, rotate: 150},
  {top: '42%', right: '-32px', size: 100, rotate: 200},
  {bottom: '30%', left: '-30px', size: 115, rotate: 260},
  {top: '-26px', left: '12%', size: 95, rotate: 300},
  {bottom: '-28px', right: '10%', size: 105, rotate: 45},
  {top: '64%', left: '-22px', size: 90, rotate: 120},
  {top: '18%', right: '-22px', size: 95, rotate: 330},
];

const FADE_MS = 1800;
const FLASH_MS = 1300;

const Splatter = ({spot, className}) => (
  <svg
    className={`vtmStain ${className}`}
    viewBox="0 0 100 100"
    aria-hidden="true"
    style={{top: spot.top, left: spot.left, right: spot.right, bottom: spot.bottom, width: spot.size, height: spot.size, '--stain-rotate': `${spot.rotate}deg`}}
  >
    <path d="M50 18 C 62 16, 70 26, 78 24 C 88 22, 92 34, 84 42 C 80 48, 90 58, 82 66 C 74 76, 62 70, 54 80 C 46 88, 34 80, 30 70 C 26 60, 12 60, 16 48 C 20 38, 14 28, 26 24 C 34 20, 40 20, 50 18 Z" />
    <circle cx="90" cy="12" r="4" />
    <circle cx="8" cy="74" r="3" />
    <circle cx="70" cy="91" r="5" />
    <circle cx="96" cy="55" r="2.5" />
    <circle cx="22" cy="9" r="2.5" />
  </svg>
);

/**
 * Taches d'Humanité : une éclaboussure de sang séché par tache sur les bords de l'écran.
 * Remords réussi : elles s'effacent lentement. Humanité perdue : elles disparaissent d'un coup, l'écran s'assombrit.
 */
const VtmStainSplatters = ({stains, humanity}) => {
  const previous = useRef({stains, humanity});
  const [fading, setFading] = useState(0); // nombre de taches qui s'effacent
  const [flash, setFlash] = useState(0);

  useEffect(() => {
    const change = stainChange(previous.current, {stains, humanity});
    const before = previous.current.stains;
    previous.current = {stains, humanity};
    if (change === 'cleansed') {
      setFading(before);
      const timer = setTimeout(() => setFading(0), FADE_MS);
      return () => clearTimeout(timer);
    }
    if (change === 'degenerated') {
      setFading(0);
      setFlash(Date.now());
      const timer = setTimeout(() => setFlash(0), FLASH_MS);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [stains, humanity]);

  const shown = Math.min(stains, SPOTS.length);
  return (
    <>
      {SPOTS.slice(0, Math.max(shown, Math.min(fading, SPOTS.length))).map((spot, index) => (
        <Splatter key={index} spot={spot} className={index < shown ? 'on' : 'fading'} />
      ))}
      {flash > 0 && <div key={flash} className="vtmDegenerationFlash" aria-hidden="true" />}
    </>
  );
};

export default VtmStainSplatters;
